import * as core from '../../../../../../../core'

import { query } from './computed-risk-level.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.subaward-details.widgets.computed-risk-level',
    description: 'Computed Risk Level',
    name: 'Computed Risk Level',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
